export const Concielge = {
  hurigana: 'ジュ',
  name: 'コンシェル樹',
  subName: '（別名：いつきさん）',
  characters: [
    'あらゆる生命を受け入れる、森に佇む大樹のような懐かしさと包容力を持つ。',
    '「コンシェル樹（ジュ）」の名前から‘いつき’さんと呼ばれることが多い。',
    '自ら多くを語ることはないが、問いかけにはすべて的確に答えてくれる。',
    '人智を超えた神秘的な存在で、見える人にだけ見える。',
    '体長は自在で、小規模マンションや山サイズまで様々。',
    '穏やかで優雅。誰かが困っているときにそっと助けてくれる。',
    '常に帽子をかぶり、その中は謎。諸説あるが、誰も見たことがない。',
  ],
  image: 'top-human.svg',
  imageWidth: 224,
}

export const FriendItemList = [
  {
    name: 'ピーワン',
    characters: [
      'おっとり。素直。',
      'オスっぽい見た目だが、特に性別はないらしい。',
      '犬のようだが、動物なのか野菜なのか謎。',
      '鳴き声は「ワン」と聞こえるが、時々「ピー」と小さく鳴く時もある',
      '種から植物のように育ち、兄弟が沢山いる。',
      '収穫の時に、マズルの形しだいではピーニャになるらしい。',
      '好きな子は「パップリ」',
    ],
    image: 'friend01.png',
    imageWidth: 242,
  },
  {
    name: 'ピーニャ',
    characters: [
      'はずかしがり屋だが、好奇心は旺盛。なにかあると覗かずにはいられない。',
      '鳴き声は「ニャ」と聞こえるが、時々「ピー」と小さく鳴く時もある',
      '一説では、しっぽを切るとピーワンになる、ともいわれている。',
      '好きな食べ物は、ひき肉とたけのこ。中華風味が好き',
    ],
    image: 'friend02.png',
    imageWidth: 171,
  },
  {
    name: 'ピー',
    characters: [
      '「ピー」としか鳴かない。',
      '仲間好きで群れる習性があるが、単独行動も好き',
      '羽を広げて飛ぶ時に種を落とすので、どんどん増殖する。',
      '細長い体形の亜種もおり、中には激辛がまざっている。',
    ],
    image: 'friend03.png',
    imageWidth: 113,
  },
  {
    name: 'パップリ',
    characters: [
      '穏やかそうに見えて、猪突猛進。',
      '潤んだ大きな瞳、近づくとフルーツのような甘い香りがほのかにする。',
      'メスっぽい見た目だが、特に性別はないらしい。',
      '鳴き声は「ワン」と聞こえるが、よく「パプパプ」と鼻を鳴らす。',
      '興奮すると「パプ――」と鼻を鳴らしながら突進してくる。',
    ],
    image: 'friend04.png',
    imageWidth: 224,
  },
];

export const InsectItemList = [
  {
    name: 'おしらせテントウ',
    subName: 'ピーテントウ、クビカザリニクキュウテントウ、パウスポットテントウ',
    characters: [
      '顔部分が肉球のように見える。',
    ],
    image: 'tentou.png',
    imageWidth: 64,
  },
  {
    name: 'ピーオオアリ',
    subName: 'パウアンテナアント',
    characters: [
      '触覚の先端が、Pmanロゴのような形状をしている。',
      'パプリカが近くにいると、甘い香りに引き寄せられるため、パプリカからは疎まれている。',
    ],
    image: 'ant.png',
    imageWidth: 64,
  },
  {
    name: 'ニクキュウクマバチ',
    subName: 'パウテールクマバチ',
    characters: [
      '大きなお尻が目立つ、もっちりとした身体形状が特長。',
      'お尻部分に肉球の模様がある。',
      '巣を作るが、なかなか見られる機会がなく、まだ謎が多い。',
    ],
    image: 'bee.png',
    imageWidth: 64,
  },
  {
    name: 'ピーマイマイ',
    subName: 'パウフットプリントスネイル',
    characters: [
      '一般によく見られるカタツムリのようだが、繁殖期だけ肉球型に粘液跡を残す、珍新種。',
      'その身体のしくみはまだよくわかっていない。',
      '好物は野菜や植物だが、ピーマンは食べない。',
    ],
    image: 'maimai.png',
    imageWidth: 64,
  },
  {
    name: 'ピーホタル',
    subName: 'パウライトホタル',
    characters: [
      '顔部分が肉球のように見える。',
      '繁殖期には、肉乳形状の光を尻に灯す。',
      '大きい光が光った後に４つの小さな光が光り、打ち上げ花火のようなリズム。',
    ],
    image: 'hotal.png',
    imageWidth: 64,
  },
  {
    name: 'ピーモンシロ',
    subName: 'ニクキュウモンシロチョウ、パウリンクホワイトバタフライ',
    characters: [
      '連なると羽の模様が肉球のように見える。',
    ],
    image: 'monshiro.png',
    imageWidth: 64,
  },
];
